import React from 'react'
import PropTypes from 'prop-types'
import { useSwiper } from 'swiper/react' // Swiper instance авах
import classes from './Wrapper.module.css'

const Wrapper = (props) => {
  const swiper = useSwiper() // Swiper instance

  const handleNext = () => {
    if (swiper) swiper.slideNext()
  }

  const handlePrev = () => {
    if (swiper) swiper.slidePrev()
  }

  return (
    <div className={classes.Container}>
      {props.children}

      <button
        onClick={handlePrev}
        className={`${classes.NavButton} ${classes.PrevButton}`}
      >
        ‹
      </button>

      <button
        onClick={handleNext}
        className={`${classes.NavButton} ${classes.NextButton}`}
      >
        ›
      </button>
    </div>
  )
}

Wrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.any,
    PropTypes.object,
    PropTypes.element
  ])
}

export default Wrapper
